import { createStackNavigator } from "@react-navigation/stack";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WorkspaceAnalyticsMetric } from "./__generated__/WorkspaceAnalyticsDetailQuery.graphql";

export const WorkspaceAnalyticsStack =
  createStackNavigator<WorkspaceAnalyticsStackParamList>();

export type WorkspaceAnalyticsStackParamList = {
  WorkspaceAnalyticsTabs: undefined;
  WorkspaceAnalyticsDetail: {
    metric: WorkspaceAnalyticsMetric;
  };
  WorkspaceAnalyticsSinglePeriodDetail: undefined;
};

export type WorkspaceNavigationProp<
  T extends keyof WorkspaceAnalyticsStackParamList,
> = CompositeNavigationProp<
  NativeStackNavigationProp<WorkspaceAnalyticsStackParamList, T>,
  UserLoggedInNavigatorNavigationProp<"OrgHome">
>;

export type WorkspaceAnalyticsStackScreenProps<
  T extends keyof WorkspaceAnalyticsStackParamList,
> = {
  route: RouteProp<WorkspaceAnalyticsStackParamList, T>;
  navigation: WorkspaceNavigationProp<T>;
};
